import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import LdsImage from "../../components/LdsImage";
import References from "../../components/References";
import BodyImage from "../../assets/module-1/1-3-2-body.png";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_1_3 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main>
          <section className="mb-5">
            <h1 className="blue text-uppercase b mt-5">
              1.3.2 Dosing and Administration/Dosimetry
            </h1>
            <p className="mt-3">Estimated time to complete: 1 minute</p>
          </section>
          <section className="mb-5 row">
            <p>
              The recommended dose for Amyvid is 370 MBq (10 mCi), maximum 50 µg
              mass dose, administered as a single intravenous bolus in a total
              volume of 10 mL or less; follow the injection with an intravenous
              flush of 0.9% sterile sodium chloride.
            </p>
            <ul>
              <li>
                Inspect the radiopharmaceutical dose solution prior to
                administration and do not use if it contains particulate matter
                or is discolored
              </li>
              <li>
                Use aseptic technique and radiation shielding to withdraw Amyvid
                solution
              </li>
              <li>
                Assay the dose in a suitable dose calibrator prior to
                administration
              </li>
              <li>
                Inject Amyvid through a short intravenous catheter (~1.5 inches
                or less) to minimize the potential for adsorption of the drug to
                the catheter; portions of the Amyvid dose may adhere to longer
                catheters
              </li>
            </ul>
            <div className="row mt-3">
              <div className="col-sm-12 col-md-6">
                <h2 className="h5 b">Radiation Safety—Drug Handling</h2>
                <p>
                  Amyvid is a radioactive drug and should be handled with
                  appropriate safety measures to minimize radiation exposure
                  during administration. Use waterproof gloves and effective
                  shielding, including syringe shields, when handling Amyvid.
                  Radiopharmaceuticals, including Amyvid, should only be used by
                  or under the control of physicians who are qualified by
                  specific training and experience in the safe use and handling
                  of radioactive materials, and whose experience and training
                  have been approved by the appropriate governmental agency
                  authorized to license the use of radio pharmaceuticals.
                </p>
              </div>
              <div className="col-sm-12 col-md-6">
                <LdsImage
                  src={BodyImage}
                  alt="PET scan image of a human body."
                  style={{ maxWidth: "300px" }}
                  className="mx-auto d-block"
                />
              </div>
            </div>
          </section>
          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-1/module-1-3-1", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-1/module-1-3-3", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
          <References>
            <p className="fz-sm">
              Amyvid (florbetapir F 18 injection) Prescribing Information. Lilly
              USA, LLC.
            </p>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_1_1_3;
